import { gql } from 'apollo-boost';

export const getPageProfileQuery = gql`
  query {
    PageProfile {
      id
      fullname
      language
      bio
      emailAddress
      cellphoneNumber
      address
      pageName
      qrCodeUrl
      tags
      links {
        id
        title
        url
        logoName
        shortLinkUrl
      }
      shareImageUrl
      avatar {
        id
        url
        thumbnailUrl
      }
      settings {
        defaultTab
        visibleTabs
        showQrCode
        currentTheme {
          id
          palette {
            primary
            background
            cardBackground
            saparator
            coverBackaground
            coverText
            coverHasGradiant
            title
            subtitle
            description
          }
        }
      }
      language
      isDefault
      currentPlan {
        accountType
        expireDays
        isProUser
      }
    }
  }
`;

export const getPagePreviewProfileQuery = gql`
  query PageProfilePreview($pageName: String!) {
    PageProfilePreview(input: { pageName: $pageName }) {
      id
      fullname
      language
      bio
      emailAddress
      cellphoneNumber
      qrCodeUrl
      bookmarkedLinks {
        id
        title
        url
        logoName
        shortLinkUrl
      }
      links {
        id
        title
        url
        logoName
        shortLinkUrl
      }
      avatar {
        id
        url
        thumbnailUrl
      }
      posts {
        id
        title
        description
        shortLink
        shortLinkUrl
        images {
          id
          url
          thumbnailUrl
        }
        category {
          id
          title
        }
      }
      products {
        id
        code
        title
        description
        shortLink
        shortLinkUrl
        images {
          id
          url
          thumbnailUrl
        }
        isAvailable
        category {
          id
          title
        }
        price
        discount
      }
    }
  }
`;

export const getAvatarsQuery = gql`
  query {
    Avatars {
      id
      url
      thumbnailUrl
    }
  }
`;

export const getTagsQuery = gql`
  query {
    Tags {
      id
      title
    }
  }
`;

export const editProfileQuery = gql`
  mutation EditProfile(
    $pageName: String!
    $avatarAssetId: ID
    $fullname: String!
    $bio: String
    $emailAddress: String
    $cellphoneNumber: String
    $address: String
    $tags: [String!]
    $links: [ID!]
  ) {
    EditProfile(
      input: {
        pageName: $pageName
        avatarAssetId: $avatarAssetId
        fullname: $fullname
        bio: $bio
        emailAddress: $emailAddress
        cellphoneNumber: $cellphoneNumber
        address: $address
        tags: $tags
        links: $links
      }
    ) {
      id
      pageName
      fullname
      language
      bio
      emailAddress
      cellphoneNumber
      address
      bookmarkedLinks {
        id
        title
        url
        logoName
        shortLinkUrl
      }
      avatar {
        id
        url
        thumbnailUrl
      }
      tags
    }
  }
`;

export const editPageLanguageQuery = gql`
  mutation EditPageLanguage($language: PageLanguageType!) {
    EditPageLanguage(input: { language: $language })
  }
`;

export const editPageNameQuery = gql`
  mutation EditPageName($name: String!) {
    EditPageName(input: { name: $name })
  }
`;

export const editPageFullnameQuery = gql`
  mutation EditPageFullname($fullname: String!) {
    EditPageFullname(input: { fullname: $fullname })
  }
`;

export const editPageAvatarQuery = gql`
  mutation EditPageAvatar($assetId: ID!) {
    EditPageAvatar(input: { assetId: $assetId })
  }
`;

export const editPageTagsQuery = gql`
  mutation EditPageTags($tgas: [String]!) {
    EditPageTags(input: { tgas: $tgas })
  }
`;

export const editSettingQuery = gql`
  mutation EditProfile(
    $defaultTab: PageDefaultTab!
    $visibleTabs: [PageDefaultTab]!
    $showQrCode: Boolean!
  ) {
    EditSetting(
      input: {
        defaultTab: $defaultTab
        visibleTabs: $visibleTabs
        showQrCode: $showQrCode
      }
    ) {
      defaultTab
      visibleTabs
      showQrCode
    }
  }
`;

export const getPagePreviewSettingQuery = gql`
  query PageSettingPreview($pageName: String!) {
    PageSettingPreview(input: { pageName: $pageName }) {
      theme {
        palette {
          primary
          background
          cardBackground
          saparator
          coverBackaground
          coverText
          coverHasGradiant
          title
          subtitle
          description
        }
      }
      defaultTab
      visibleTabs
      showQrCode
    }
  }
`;
